// This file is generated by pnpm icons:generate. Do not edit.

import {VerifierCheck as CanonicalVerifierCheck} from './brands/VerifierCheck'

/** @deprecated Import VerifierCheck from `#/components/icons/brands/VerifierCheck` instead. */
export const VerifierCheck = CanonicalVerifierCheck
